import { render, staticRenderFns } from "./AddFormalApplicationDialog.vue?vue&type=template&id=47df5deb&scoped=true"
import script from "./AddFormalApplicationDialog.vue?vue&type=script&lang=js"
export * from "./AddFormalApplicationDialog.vue?vue&type=script&lang=js"
import style0 from "./AddFormalApplicationDialog.vue?vue&type=style&index=0&id=47df5deb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47df5deb",
  null
  
)

export default component.exports